import { useQuery } from "@tanstack/react-query";
import { publicApi, imgSrc } from "@/lib/api";

export function useSiteSettings() {
  const { data } = useQuery({ queryKey: ["settings"], queryFn: publicApi.settings, staleTime: 300000 });
  return { logo: imgSrc(data?.logo), hero: imgSrc(data?.hero) };
}
